/* eslint-disable no-dupe-keys */
export default {
  task_definition: {
    name: '积分任务',
    // 属性（一般与对象内容匹配）
    prop: {
      title: '标题',
      icon: '图标',
      app_visible: 'APP可视',
      task_type: '类型',
      reward_points: '奖励积分',
      description: '描述',
      sort_number: '排序编号',
      redirect_setting: '跳转配置',
      redirect_android_page: '安卓页面配置',
      redirect_iOS_page: 'iOS页面配置',
      redirect_miniprogram_page: '小程序页面配置',
      app_page: 'APP跳转页',
      trigger: '活动优惠奖励',
      created_at: '创建时间',
      updated_at: '更新时间',
      status: '状态',
      last_trigger_time: '最近参与时间'
    },
    // Enum的属性
    // Boolean的属性
    app_visibles: { true: '是', false: '否' },
    // 占位提示
    placeholder: {
      search_keyword: '查询标题'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      participations: '参与记录'
    },
    titles: {
      base_info: '基本信息',
      trigger_info: '优惠活动信息'
    },
    tips: {
      icon_size: '推荐宽高比例为1:1，尺寸为 60x60，< 500KB'
    }
  }
}
